import Page from '../variants/rebrand-product';

export default Page;
